import React, { useState } from 'react'
import ReportHeader from '../../../common/ReportHeader'
import { topUpMenu } from '../../../../redux/Actions'
import { useDispatch } from 'react-redux'
import { Box, Button, Divider, Grid } from '@mui/material'
import CustomDatePicker from '../../../common/CustomDatePicker'
import { formatDate } from '../../../../utilityFunctions'
import TextBox from '../../../common/TextBox'
import TrackTopupDetails from './TrackTopupDetails'
import TrackTopupTable from './TrackTopupTable'
import { TrackTopUp } from '../../../../redux/KSRTC_Redux/bookingPage/bookingAction'
import moment from 'moment/moment'
import Alert from '../../../common/Alert'

const TrackTopup = () => {
    const dispatch = useDispatch()

    const [filterValue, setFilterValue] = useState({
        fromDate: formatDate(window.getTime ? window.getTime() : new Date()),
        toDate: formatDate(window.getTime ? window.getTime() : new Date()),
        code: '',
        ticketNo: '',
        refrenace: ''
    })
    const [topUpList, setTopUpList] = useState([])
    const [topUpData, setTopUpData] = useState(null)
    const [showAlert, setShowAlert] = useState({
        open: false,
        msg: '',
        alertType: 'error'
    })

    const clearResults = () => {
        setTopUpList([])
        setTopUpData(null)
    }

    const handleSetAlert = (msg, alertType = 'error') => {
        setShowAlert({ open: true, msg, alertType })
    }

    const handleField = (event) => {
        const { name, value } = event.target
        clearResults()
        if (name === 'code') {
            setFilterValue((prev) => ({
                ...prev,
                code: value,
                ticketNo: '',
                refrenace: '',
                fromDate: '',
                toDate: '',
            }))
        } else if (name === 'ticketNo') {
            setFilterValue((prev) => ({
                ...prev,
                ticketNo: value,
                code: '',
                refrenace: '',
                fromDate: '',
                toDate: '',
            }))
        } else if (name === 'refrenace') {
            setFilterValue((prev) => ({
                ...prev,
                refrenace: value,
                code: '',
                ticketNo: '',
                fromDate: '',
                toDate: '',
            }))
        }
    }

    const handleDateChange = (field, value) => {
        const formatted = formatDate(value)
        clearResults()
        setFilterValue((prev) => {
            const next = {
                ...prev,
                code: '',
                ticketNo: '',
                refrenace: '',
            }
            if (field === 'fromDate') {
                if (!prev.toDate || new Date(value) >= new Date(prev.toDate)) {
                    next.fromDate = formatted
                    next.toDate = formatted
                } else {
                    next.fromDate = formatted
                    next.toDate = prev.toDate
                }
            } else {
                next.fromDate = prev.fromDate || formatted
                next.toDate = formatted
            }
            return next
        })
    }

    const handleSearch = () => {
        const code = (filterValue?.code || '').trim()
        const ticketNo = (filterValue?.ticketNo || '').toString().trim()
        const reference = (filterValue?.refrenace || '').trim()

        let Search = ''
        let IsSearch = 'RD'
        let FromDate = ''
        let ToDate = ''

        if (code) {
            Search = code
            IsSearch = 'CC'
        } else if (ticketNo) {
            Search = ticketNo
            IsSearch = 'TN'
        } else if (reference) {
            Search = reference
            IsSearch = 'RN'
        } else if (filterValue?.fromDate && filterValue?.toDate) {
            FromDate = moment(filterValue.fromDate).format('YYYY-MM-DD')
            ToDate = moment(filterValue.toDate).format('YYYY-MM-DD')
            Search = ''
            IsSearch = 'RD'
        } else {
            handleSetAlert('Please select date range or enter Franchisee Code / Ticket No / Ob Reference')
            return
        }

        const body = {
            FromDate,
            ToDate,
            Search,
            IsSearch,
        }
        dispatch(TrackTopUp(body)).then((res) => {
            if (res?.data?.status) {
                const tableData = res?.data?.Data?.Table || []
                if (tableData.length > 1) {
                    setTopUpList(tableData)
                    setTopUpData(null)
                } else if (tableData.length === 1) {
                    setTopUpList([])
                    setTopUpData(tableData[0])
                } else {
                    clearResults()
                    handleSetAlert('No Data Found')
                }
            } else {
                clearResults()
                handleSetAlert(res?.data?.Message || 'No Data Found')
            }
        }).catch(() => {
            clearResults()
            handleSetAlert('Unable to fetch top up details')
        })
    }

    const handleSelectRow = (row) => {
        setTopUpData(row)
        setTopUpList([])
    }

    const handleReset = () => {
        setFilterValue({
            fromDate: formatDate(window.getTime ? window.getTime() : new Date()),
            toDate: formatDate(window.getTime ? window.getTime() : new Date()),
            code: '',
            ticketNo: '',
            refrenace: ''
        })
        clearResults()
    }
    return (
        <>
            <ReportHeader mainHeaderName="Top Up" headerName={'Track Top Up'} openSubMenu={() => dispatch(topUpMenu(true))} fixedTopPosition={true} defaultTopPosition={'40px'} />
            <Box>
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                    columnSpacing={{ xs: 1.5 }}
                    sx={{
                        padding: "16px",
                    }}
                >
                    <Grid item md={1.9} className='disabledDate'>
                        <CustomDatePicker label={'Transaction From Date'} id='fromDate' selectedDate={filterValue?.fromDate}
                            onChange={(value) => handleDateChange('fromDate', value)}
                            minDate={""}
                        />
                    </Grid>
                    <Grid item md={1.9} className='disabledDate'>
                        <CustomDatePicker label={'Transaction To Date'} id='toDate' selectedDate={filterValue?.toDate}
                            onChange={(value) => handleDateChange('toDate', value)}
                            minDate={filterValue?.fromDate}
                        />
                    </Grid>
                    <Grid item md={0.2} style={{ paddingLeft: "6px" }}>
                        <span>OR</span>
                    </Grid>
                    <Grid item md={2}>
                        <TextBox
                            type="text"
                            label="Franchisee Code"
                            value={filterValue.code}
                            onChange={handleField}
                            name="code"

                        />
                    </Grid>
                    <Grid item md={0.2} style={{ paddingLeft: "6px" }}>
                        <span>OR</span>
                    </Grid>
                    <Grid item md={2}>
                        <TextBox
                            type="number"
                            label="Ticket No"
                            value={filterValue.ticketNo}
                            onChange={handleField}
                            name="ticketNo"

                        />
                    </Grid>
                    <Grid item md={0.2} style={{ paddingLeft: "6px" }}>
                        <span>OR</span>
                    </Grid>
                    <Grid item md={2}>
                        <TextBox
                            type="text"
                            label="Ob Refrenace"
                            value={filterValue.refrenace}
                            onChange={handleField}
                            name="refrenace"

                        />
                    </Grid>
                    <Grid item md={0.8}>
                        <Button
                            id={`searchTrackTicket`}
                            variant="contained"
                            size="medium"
                            className={`btn-orange`}
                            onClick={handleSearch}

                        >
                            search
                        </Button>
                    </Grid>
                    <Grid item md={0.8}>
                        <Button
                            id={`resetButton`}
                            variant="outlined"
                            size="medium"
                            className="btn-orange-outline"
                            onClick={handleReset}

                        >
                            RESET
                        </Button>
                    </Grid>
                </Grid>
                <Divider />
                {topUpList.length > 1 && (
                    <TrackTopupTable tableData={topUpList} onSelect={handleSelectRow} />
                )}
                <TrackTopupDetails topUpData={topUpData} />
            </Box>
            {showAlert.open && (
                <Alert
                    msg={showAlert.msg}
                    alertType={showAlert.alertType}
                    close={() => setShowAlert({ open: false, msg: '', alertType: 'error' })}
                    buttonText="Ok"
                />
            )}
        </>
    )
}

export default TrackTopup
